import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { Search, PenTool, Rocket, TrendingUp } from 'lucide-react'

const steps = [
  {
    icon: Search,
    title: 'Análise Detalhada',
    description: 'Análise detalhada do negócio e dos processos reais.',
  },
  {
    icon: PenTool,
    title: 'Criação à Medida',
    description:
      'Criação da aplicação com automação e IA ajustadas à operação.',
  },
  {
    icon: Rocket,
    title: 'Implementação',
    description: 'Implementação com formação simples da equipa.',
  },
  {
    icon: TrendingUp,
    title: 'Evolução Contínua',
    description:
      'Evolução contínua do sistema com base no uso e nos dados gerados.',
  },
]

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 bg-slate-50">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Como funciona
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Um processo estruturado para transformar a sua operação sem causar
            disrupção.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <ScrollReveal key={index} delay={index * 150} className="relative">
              <div className="flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-2xl bg-white border border-slate-200 shadow-sm flex items-center justify-center mb-6 group-hover:scale-110 group-hover:border-primary/50 group-hover:shadow-primary/10 transition-all duration-300">
                  <step.icon className="w-8 h-8 text-slate-700 group-hover:text-primary transition-colors" />
                </div>
                <div className="absolute top-8 left-1/2 w-full h-0.5 bg-slate-200 -z-10 hidden md:block" />
                {index === steps.length - 1 ? null : (
                  <div className="absolute top-8 left-[50%] right-[-50%] h-0.5 bg-slate-200 -z-10 hidden md:block" />
                )}
                <span className="text-sm font-bold text-primary mb-2 bg-indigo-50 px-2 py-0.5 rounded">
                  Passo {index + 1}
                </span>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
